import React from 'react'
import { I18n } from '@front/volcanion'

import { Box, Typography } from '@mui/material'

const ImportList = ({ fails_count, incorrects_count, success_count, total }) =>
  <Box display='flex' justifyContent='center' alignItems='flex-end' fontSize='h5.fontSize' color='primary.main' p={2} boxShadow={2}>
    <Typography mx={1} variant='h5'>{I18n.t('import.report')}</Typography>
    <Typography mx={1} variant='h5' fontWeight='bold' color='error.main'>{I18n.t('fail.count', { count: fails_count, total })}</Typography>
    <Typography mx={1} variant='h5' fontWeight='bold' color='warning.main'>{I18n.t('incorrect.count', { count: incorrects_count, total })}</Typography>
    <Typography mx={1} variant='h5' fontWeight='bold' color='success.main'>{I18n.t('sucess.count', { count: success_count })}</Typography>
    <Typography mx={1} variant='h5' fontWeight='bold' color='primary.main'>{I18n.t('quotation.total.label', { count: 1 })}{`: ${total}`}</Typography>
  </Box>

export default React.memo(ImportList)
